export default {
  path: 'account',
  meta: { protected: true },
  children: [
    {
      path: '',
      component: () => import('src/pages/shared/account/AccountPage.vue'),
      children: [
        {
          path: '',
          name: 'AccountHome',
          component: () => import('src/components/shared/account/personal/AccountPersonalProfile.vue'),
        },
        {
          path: 'orders',
          name: 'AccountOrders',
          component: () => import('src/components/shared/account/AccountOrderHistory.vue'),
        },
        {
          path: 'watchlist',
          name: 'AccountWatchlist',
          component: () => import('src/components/shared/account/watchlist/AccountWatchlist.vue'),
        },
        {
          path: 'wallet',
          name: 'AccountWallet',
          component: () => import('src/components/shared/account/wallet/AccountWallet.vue'),
        },
        {
          path: 'returns',
          name: 'AccountReturns',
          component: () => import('src/components/shared/account/returns/AccountReturns.vue'),
          children: [
            {
              path: ':returnItemId',
              name: 'AccountReturnItem',
              component: () => import('src/components/shared/account/returns/AccountReturnItem.vue'),
            },
          ],
        },
        {
          path: 'business',
          name: 'AccountBusiness',
          component: () => import('src/components/shared/account/business/AccountBusinessProfile.vue'),
        },
      ],
    },
    { path: 'setup', name: 'AccountSetup', component: () => import('src/pages/shared/account/AccountSetupPage.vue') },
    {
      path: 'delete',
      name: 'AccountDelete',
      component: () => import('src/pages/shared/account/AccountDeletionPage.vue'),
    },
    {
      path: 'delete/confirmed',
      name: 'AccountDeleteConfirmed',
      component: () => import('src/pages/shared/account/AccountDeletionConfirmationPage.vue'),
    },
    {
      path: 'delete/in-progress',
      name: 'AccountDeleteInProgress',
      component: () => import('src/pages/shared/account/AccountDeletionInProgressPage.vue'),
    },
  ],
}
